/**
 * The icon set's motion, as one stylesheet every animated icon shares (React hoists it once).
 *
 * A part moves only when its glyph says why (`Glyph.motion`). A `state` motion runs while the
 * icon is drawn with `animate`; a `hover` motion runs while a person points at the icon or the
 * control holding it, and runs on its own with `animate`. Nothing moves for a person who asked
 * for reduced motion.
 */
export const ICON_MOTION_CSS = `
[data-sx-motion]{transform-box:fill-box;transform-origin:center}
[data-sx-motion="spin"]{transform-box:view-box;transform-origin:12px 12px}
[data-sx-motion="close-left"],[data-sx-motion="close-right"]{transition:transform 160ms cubic-bezier(.22,1,.36,1)}
@keyframes sx-icon-draw{0%{stroke-dashoffset:1}60%,100%{stroke-dashoffset:0}}
@keyframes sx-icon-pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.45;transform:scale(.7)}}
@keyframes sx-icon-twinkle{0%,100%{transform:scale(1) rotate(0)}35%{transform:scale(.62) rotate(-18deg)}60%{transform:scale(1.12) rotate(6deg)}}
@keyframes sx-icon-close-left{0%,100%{transform:translateX(0)}50%{transform:translateX(1.5px)}}
@keyframes sx-icon-close-right{0%,100%{transform:translateX(0)}50%{transform:translateX(-1.5px)}}
@keyframes sx-icon-flow{0%{transform:translateY(2px);opacity:.2}35%{opacity:1}100%{transform:translateY(-1.5px);opacity:.2}}
@keyframes sx-icon-sink{0%{transform:translateY(-1.5px);opacity:.2}35%{opacity:1}100%{transform:translateY(1.5px);opacity:.2}}
@keyframes sx-icon-blink{0%,100%{opacity:1}50%{opacity:.25}}
@keyframes sx-icon-shimmer{0%,100%{opacity:.3}50%{opacity:1}}
@keyframes sx-icon-spin{to{transform:rotate(360deg)}}
@media (prefers-reduced-motion:no-preference){
svg[data-sx-animate] [data-sx-motion="draw"]{stroke-dasharray:1;animation:sx-icon-draw 1.8s cubic-bezier(.16,1,.3,1) infinite}
svg[data-sx-animate] [data-sx-motion="pulse"]{animation:sx-icon-pulse 1.4s ease-in-out infinite}
svg[data-sx-animate] [data-sx-motion="twinkle"]{animation:sx-icon-twinkle 2.2s ease-in-out infinite}
svg[data-sx-animate] [data-sx-motion="close-left"]{animation:sx-icon-close-left 1.2s ease-in-out infinite}
svg[data-sx-animate] [data-sx-motion="close-right"]{animation:sx-icon-close-right 1.2s ease-in-out infinite}
svg[data-sx-animate] [data-sx-motion="flow"]{animation:sx-icon-flow 1.1s ease-out infinite}
svg[data-sx-animate] [data-sx-motion="sink"]{animation:sx-icon-sink 1.1s ease-out infinite}
svg[data-sx-animate] [data-sx-motion="blink"]{animation:sx-icon-blink 2.4s ease-in-out infinite}
svg[data-sx-animate] [data-sx-motion="shimmer"]{animation:sx-icon-shimmer 1.6s ease-in-out infinite}
svg[data-sx-animate] [data-sx-motion="spin"]{animation:sx-icon-spin .9s linear infinite}
svg[data-sx-hover]:hover [data-sx-motion="close-left"],:is(a,button,[role="button"],[role="menuitem"],.group):hover svg[data-sx-hover] [data-sx-motion="close-left"]{transform:translateX(1.5px)}
svg[data-sx-hover]:hover [data-sx-motion="close-right"],:is(a,button,[role="button"],[role="menuitem"],.group):hover svg[data-sx-hover] [data-sx-motion="close-right"]{transform:translateX(-1.5px)}
}
`;
